const firebaseConfig = {
    apiKey: "AIzaSyCDxv4AWHbvIA7Y6Ao4Q2euxnhlegHDwxc",
    authDomain: "versatile-tourism-agency.firebaseapp.com",
    projectId: "versatile-tourism-agency",
    storageBucket: "versatile-tourism-agency.appspot.com",
    messagingSenderId: "696763280337",
    appId: "1:696763280337:web:5b407c78e41ae3bc6e8ef0"
};
export default firebaseConfig;